import moment from 'moment-timezone';

export const getDateRange = dateString => {
  const date = moment(dateString, 'YYYY-MM-DD');
  const start_date = date.clone();
  const end_date = date.clone();
  const dayOfWeek = date.day();

  const startingTime = { hour: 6, minute: 1, second: 0 };
  const endingTime = { hour: 6, minute: 0, second: 0 };

  switch (dayOfWeek) {
    case 0: //sunday (dining report)
      start_date.add(-9, 'days').set(startingTime);
      end_date.add(-2, 'days').set(endingTime);
      break;
    case 1: //monday
      start_date.add(-3, 'days').set(startingTime);
      end_date.add(-3, 'days').set({ hour: 23, minute: 59, second: 0 });
      break;
    case 2: //tuesday
      start_date.add(-1, 'days').set(startingTime);
      end_date.set(endingTime);
      break;
    case 3: //wednesday
      start_date.add(-1, 'days').set(startingTime);
      end_date.set(endingTime);
      break;
    case 4: //thursday
      start_date.add(-1, 'days').set(startingTime);
      end_date.set(endingTime);
      break;
    case 5: //friday
      start_date.add(-1, 'days').set(startingTime);
      end_date.set(endingTime);
      break;
    case 6: //saturday (hot headlines)
      start_date.add(-8, 'days').set(startingTime);
      end_date.add(-1, 'days').set(endingTime);
      break;
    default:
      break;
  }
  //Includes posts between {getDateRange(formik.values.sendDate).start} and{' '}
  //  {getDateRange(formik.values.sendDate).end}
  return {
    startDate: start_date.tz('America/Chicago').format('YYYY-MM-DD'),
    start: start_date,
    endDate: end_date.tz('America/Chicago').format('YYYY-MM-DD'),
    end: end_date,
    description: `Includes posts between ${start_date.tz('America/Chicago').format('LLL')} and ${end_date
      .tz('America/Chicago')
      .format('LLL')}`,
  };
};
